<div class="space-y-10">
  <div class="space-y-8">
    <div class="text-center space-y-3">
      <h3 class="text-3xl font-bold text-neutral-12 tracking-tight">Quel est votre statut ?</h3>
      <p class="text-neutral-11 text-base max-w-md mx-auto leading-relaxed">
        Choisissez votre mode d'exercice pour adapter les outils à vos besoins.
      </p>
    </div>

    <aura-selection-card-group [formField]="formTree.type" class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <aura-selection-card
        value="titulaire"
        label="Titulaire de carte T"
        description="Vous gérez votre propre agence et possédez une carte professionnelle."
        icon="business_center"
      />

      <aura-selection-card
        value="mandataire"
        label="Mandataire / Négociateur"
        description="Vous êtes rattaché à une agence et possédez une attestation habilitée."
        icon="person"
      />
    </aura-selection-card-group>

    @if (formTree.type().errors().length && formTree.type().touched()) {
      <p
        class="text-error-9 dark:text-error-11 text-center text-sm font-semibold bg-error-2 dark:bg-error-3/30 py-3 rounded-xl border border-error-4 dark:border-error-5"
      >
        Veuillez sélectionner un statut pour continuer.
      </p>
    }
  </div>
</div>
